import { Injectable } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';


export const CustomBreakpointNames = {
    extraSmall: 'extraSmall',
    small: 'small',
    bitLargerThanSmall: 'bitLargerThanSmall',
    bitLargerThanSmallToMedium: 'bitLargerThanSmallToMedium',
    smallToMedium: 'smallToMedium',
    medium: 'medium',
    mediumToLarge: 'mediumToLarge',
    large: 'large',
    extraLarge: 'extraLarge',
};

@Injectable({
    providedIn: 'root'
})
export class BreakpointsService {
    breakpoints: object = {
        '(max-width: 220px)': CustomBreakpointNames.extraSmall,
        '(max-width: 360px)': CustomBreakpointNames.small,
        '(max-width: 375px)': CustomBreakpointNames.bitLargerThanSmallToMedium,
        '(max-width: 414px)': CustomBreakpointNames.smallToMedium,
        '(max-width: 1366px)': CustomBreakpointNames.medium,
        '(max-width: 1536px)': CustomBreakpointNames.mediumToLarge,
        '(max-width: 1920px)': CustomBreakpointNames.large,
        '(min-width: 2400px)': CustomBreakpointNames.extraLarge
    };

    getBreakpoints(): string[] {
        return Object.keys(this.breakpoints);
    }

    getBreakpointName(breakpointValue): string {
        return this.breakpoints[breakpointValue];
    }

    constructor() {
    }
}